import { Component, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Inject } from '@angular/core';
import { SerieEstadistica } from 'src/app/components/shared/entities/serie-estadistica';

@Component({
  selector: 'app-detalle-serie-dialog',
  templateUrl: './detalle-serie-dialog.component.html',
  styleUrls: ['./detalle-serie-dialog.component.css']
})
export class DetalleSerieDialogComponent implements OnInit {

  public detalleSerie: SerieEstadistica = new SerieEstadistica();

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<DetalleSerieDialogComponent>) { }

  ngOnInit(): void {
    this.detalleSerie = this.data.dataKey;   
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
